import styled, { css } from 'styled-components';
import FormWrapper from '../../components/FormWrapper';
import TableComponent from '../../components/Table';
import ButtonComponent from '../../components/Button';

export const Container = styled.section`
  margin-bottom: 30px;
  grid-column: 2/3;
  @media (max-width: 768px) {
    grid-column: 1;
  }
  @media (min-width: 769px) and (max-width: 1600px) {
    grid-column: 1/4;
  }
`;

export const IncludeDependentsContainer = styled.div`
  grid-column: 2/3;
  @media (max-width: 768px) {
    grid-column: 1;
  }

  /* @media (min-width: 769px) {
    overflow-y: hidden;
  } */

  @media (min-width: 769px) and (max-width: 2500px) {
    grid-column: 1/4;
    padding: 0 0px;
  }

  form {
    display: flex;
    flex-wrap: wrap;
    > button {
      text-transform: uppercase;

      &.marginRight {
        margin-right: auto;
      }
      &.marginLeft {
        margin-left: auto;
      }
    }
    &.request-copy-card,
    &.change-contract {
      margin-bottom: 30px;
    }
    &.form-termination-beneficiary {
      > button {
        margin: 0;
        &:nth-of-type(1) {
          margin-right: auto;
        }
      }
    }
    &.form-change-product-details {
      margin-bottom: 24px;
      & + form {
        margin-bottom: 30px;
      }
    }
    &.form-change-request-datasheet {
      margin-bottom: 24px;
    }
    &.actions-include-dependent {
      margin: 24px 0 30px;
    }
    &.depentent-include {
      /* .select-city button:first-child,
      .select-state button:first-child,
      .select-genre button:first-child,
      .select-uf button:first-child,
      .select-marital-status button:first-child {
        display: none;
      } */

      @media (max-width: 768px) {
        > div {
          &:nth-child(5),
          &:nth-child(6) {
            width: auto;
            flex: 1 1;
          }
          &:nth-child(14),
          &:nth-child(15) {
            width: auto;
            min-width: 45%;
            flex: 1 1;
          }
          &:nth-child(16),
          &:nth-child(17) {
            width: auto;
            min-width: 45%;
            flex: 1 1;
          }
        }
      }
    }
    &.beneficiaries-home {
      @media (max-width: 768px) {
        > div {
          &:nth-child(4),
          &:nth-child(5) {
            width: auto;
            flex: 1 1;
          }
        }
      }
    }
  }

  div.table-wrapper-beneficiaries {
    margin-top: 24px;
    div.p-datatable-scrollable-view.p-datatable-frozen-view {
      div.p-datatable-scrollable-header {
        background: transparent;
      }
      table {
        tbody {
          tr.p-row-expanded {
            opacity: 0;
            pointer-events: none;
          }
          tr.p-highlight.p-selectable-row {
            border-left-width: 2px !important;
          }
        }
      }
    }
    div.p-datatable-scrollable-view.p-datatable-unfrozen-view {
      div.p-datatable-scrollable-header {
        background: transparent;
      }
      table {
        tbody {
          tr.p-highlight.p-selectable-row {
            border-left: none !important;
          }
        }
      }
    }
    table {
      th {
        /* word-break: break-word; */
        height: 50px;
        span {
          display: flex;
          height: 1rem;
          align-items: center;
        }
        &.frozen {
          border-radius: 10px 0 0 0 !important;
        }
        &.no-rounded {
          border-radius: 0 0 0 0 !important;
        }
      }
      tr.p-highlight {
        td.centered {
          > label {
            > img {
              ${(props) =>
                props.theme.title === 'dark' &&
                css`
                  filter: grayscale(1) brightness(1.4);
                `}
            }
          }
        }
      }
      td {
        white-space: nowrap;
        &:not(.centered) {
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &.centered {
          overflow: visible !important;

          > label {
            position: relative;
            > img {
              display: inline;
              transform: translateY(1px);

              filter: grayscale(1) brightness(0.4);

              transition: 300ms;
            }
            &::before {
              content: attr(data-hover);
              position: absolute;
              background: ${(props) => props.theme.colors.palet.institutional4};
              padding: 4px 10px;
              font-family: 'Unimed-Sans-Bold';
              color: ${(props) => props.theme.colors.palet.institutional2};
              top: calc(-100% - 16px);
              right: 50%;
              border-radius: 5px 5px 0 5px;
              font-size: 0.65rem;

              opacity: 0;
              visibility: hidden;
              transform: translateY(10px);
              transition: 300ms;
            }
            &::after {
              content: '';
              position: absolute;
              top: -100%;
              right: 50%;
              border: 5px solid
                ${(props) => props.theme.colors.palet.institutional4};
              border-left-color: transparent;
              border-bottom-color: transparent;

              opacity: 0;
              visibility: hidden;
              transform: translateY(10px);
              transition: 300ms;
            }
            &:hover {
              > img {
                filter: grayscale(0) !important;
              }
              &::after,
              &::before {
                opacity: 1;
                visibility: visible;
                transform: translateY(0);
              }
            }
            @media (max-width: 768px) {
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50px);
              z-index: 1;

              > img {
                width: 20px;
                filter: grayscale(1) invert(1) brightness(0) invert(1) sepia(1);
              }
            }
          }
        }
      }
      tr:nth-child(1) {
        td.centered {
          label {
            &::before {
              top: calc(100% + 7px);
              z-index: 1;
            }
            &::after {
              top: 100%;
              border: 5px solid
                ${(props) => props.theme.colors.palet.institutional4};
              border-left-color: transparent;
              border-top-color: transparent;
            }
          }
        }
      }
    }
  }
`;

export const SerchDataToTableContainer = styled(FormWrapper)`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    > div {
      &:nth-child(3),
      &:nth-child(4) {
        width: auto;
        flex: 1 1 0;
      }
    }
  }
`;

export const Table = styled(TableComponent)``;

export const ActionsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  column-gap: 8px;

  @media (max-width: 768px) {
    width: calc(100vw - 100px);
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    row-gap: 16px;
  }
  > button.marginRight {
    margin-right: auto;
  }
`;

export const ModalFormWrapper = styled(FormWrapper)`
  display: flex;
  flex-wrap: wrap;
  button {
    & + button {
      margin-left: auto;
    }
  }
`;

export const ModalContainer = styled.div`
  h2 {
    font-family: 'Unimed-Sans-SemiBold';
  }

  display: flex;
  flex-direction: column;
  position: relative;
  width: 350px;

  @media (max-width: 768px) {
    width: 220px;
  }
`;

export const ModalPart = styled.div``;

export const FilesContainer = styled.div`
  max-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: 24px 0;

  overflow-y: auto;
  button {
    font-family: 'Unimed-Sans-SemiBold';
    border: none;
    outline: none;
    background: transparent;
    color: ${(props) => props.theme.colors.text.primary};
    transition: 300ms;
    &:hover {
      color: ${(props) => props.theme.colors.text.black};
    }
  }
`;

export const ButtonContainerModal = styled.div`
  padding-top: 15px;
`;

export const ModalButton = styled(ButtonComponent)`
  margin-top: 10px;
`;
